module.exports = __webpack_public_path__ + "img/Skirt-Front-B3-Db-Fc-Ga-Hc-Ia.e3547286.png";